<template>
  <div id="toast-container" class="toast-bottom-right" aria-live="polite" aria-atomic="true">
    <!--
      Renders the alerts queued by `alertService`, replacing the toastr markup that `#toast-container`
      used to hold in `booking.pug` and `login.pug` (step 27 of #614).

      The markup and the classes are toastr's, on purpose: `app.css` styles `.toast-success`,
      `.toast-title` and friends, and `web/css/style.css` carries the app's colour overrides, so
      reproducing the same elements is what keeps an alert looking exactly as it did.

      This started as BootstrapVue's `b-toast` with the same classes. It does not work here: under
      Vue 2.7 it renders an empty placeholder and logs `[Vue warn]: $attrs is readonly` - it never
      sets the internal `localShow` that its render is gated on. Nothing about a 300px solid-coloured
      panel needed a component library, so the markup is written out instead and the behaviour that
      mattered (auto-hide, click to dismiss) lives in `alertService`.

      The comment lives inside the root element: a template comment before it would make this a
      multi-root (fragment) component, and `wrapper.attributes()` reads nothing off a fragment.
    -->
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="toast"
      :class="'toast-' + toast.type"
      v-on:click="remove(toast.id)"
    >
      <div class="toast-title">{{ toast.header }}</div>
      <div class="toast-message">{{ toast.msg }}</div>
    </div>
  </div>
</template>

<script>
import alertService from '../service/alertService.js'

export default {
  name: 'ToastHost',
  computed: {
    toasts() {
      return alertService.state.toasts
    },
  },
  methods: {
    remove(id) {
      alertService.remove(id)
    },
  },
}
</script>
